import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import { Link } from 'react-router-dom';

const EmptyCart = () => {
  const popularProducts = [
    {
      id: 1,
      name: "Fresh Bananas",
      price: 2.99,
      image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=300&h=300&fit=crop",
      category: "Fruits"
    },
    {
      id: 2,
      name: "Organic Milk",
      price: 4.49,
      image: "https://images.unsplash.com/photo-1550583724-b2692b85b150?w=300&h=300&fit=crop",
      category: "Dairy"
    },
    {
      id: 3,
      name: "Whole Wheat Bread",
      price: 3.29,
      image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=300&h=300&fit=crop",
      category: "Bakery"
    },
    {
      id: 4,
      name: "Fresh Eggs",
      price: 3.99,
      image: "https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?w=300&h=300&fit=crop",
      category: "Dairy"
    }
  ];

  const handleAddToCart = (product) => {
    const cartItem = {
      ...product,
      quantity: 1,
      stock: 50
    };

    const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    const existingItemIndex = existingCart.findIndex(item => item.id === product.id);

    if (existingItemIndex > -1) {
      existingCart[existingItemIndex].quantity += 1;
    } else {
      existingCart.push(cartItem);
    }

    localStorage.setItem('cart', JSON.stringify(existingCart));
    window.location.reload(); // Refresh to update cart
  };

  return (
    <div className="text-center py-12">
      {/* Empty Cart Illustration */}
      <div className="mb-8">
        <div className="w-32 h-32 mx-auto mb-6 bg-background rounded-full flex items-center justify-center">
          <Icon name="ShoppingCart" size={64} className="text-border" />
        </div>
        <h2 className="font-heading font-heading-semibold text-2xl text-text-primary mb-2">
          Your cart is empty
        </h2>
        <p className="text-text-secondary max-w-md mx-auto">
          Looks like you haven't added any items to your cart yet. Start shopping to fill it up!
        </p>
      </div>

      {/* Start Shopping Button */}
      <div className="mb-12">
        <Link to="/product-catalog-category-browse">
          <Button
            variant="primary"
            iconName="ArrowRight"
            iconPosition="right"
            className="px-8 py-3"
          >
            Start Shopping
          </Button>
        </Link>
      </div>

      {/* Popular Products */}
      <div className="max-w-4xl mx-auto">
        <h3 className="font-heading font-heading-semibold text-xl text-text-primary mb-6">
          Popular Products
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {popularProducts.map((product) => (
            <div key={product.id} className="bg-surface border border-border rounded-card p-4 hover:shadow-card transition-smooth">
              <div className="w-full h-32 mb-3 overflow-hidden rounded-input">
                <Image
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-left">
                <p className="text-xs text-text-secondary mb-1">{product.category}</p>
                <h4 className="font-body-semibold text-sm text-text-primary mb-2 line-clamp-2">
                  {product.name}
                </h4>
                <div className="flex items-center justify-between">
                  <span className="font-data font-data-medium text-primary">
                    ${product.price.toFixed(2)}
                  </span>
                  <Button
                    variant="primary"
                    onClick={() => handleAddToCart(product)}
                    className="p-2"
                    iconName="Plus"
                    iconSize={16}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits Section */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-primary bg-opacity-10 rounded-full flex items-center justify-center">
            <Icon name="Truck" size={24} className="text-primary" />
          </div>
          <h4 className="font-body-semibold text-text-primary mb-2">Free Delivery</h4>
          <p className="text-sm text-text-secondary">On orders over $50</p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-primary bg-opacity-10 rounded-full flex items-center justify-center">
            <Icon name="Shield" size={24} className="text-primary" />
          </div>
          <h4 className="font-body-semibold text-text-primary mb-2">Quality Guarantee</h4>
          <p className="text-sm text-text-secondary">Fresh products guaranteed</p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-primary bg-opacity-10 rounded-full flex items-center justify-center">
            <Icon name="Clock" size={24} className="text-primary" />
          </div>
          <h4 className="font-body-semibold text-text-primary mb-2">Fast Delivery</h4>
          <p className="text-sm text-text-secondary">Within 2-4 hours</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;